var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "External link"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.999.998h-4v10h10v-4",
    "data-name": "Path 10621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.001 4.003v-3h-3",
    "data-name": "Path 10622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.499 1.5-5 5",
    "data-name": "Line 117"
  }))));
};
export default SvgExternalLink;